/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Request to abort chunk upload.
 * @export
 * @interface ChunksAbortRequest
 */
export interface ChunksAbortRequest {
    /**
     * S3 key/path where chunks were uploaded
     * @type {string}
     * @memberof ChunksAbortRequest
     */
    s3Path: string;
    /**
     * Upload session ID returned from init endpoint
     * @type {string}
     * @memberof ChunksAbortRequest
     */
    uploadId: string;
}

/**
 * Check if a given object implements the ChunksAbortRequest interface.
 */
export function instanceOfChunksAbortRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "s3Path" in value;
    isInstance = isInstance && "uploadId" in value;

    return isInstance;
}

export function ChunksAbortRequestFromJSON(json: any): ChunksAbortRequest {
    return ChunksAbortRequestFromJSONTyped(json, false);
}

export function ChunksAbortRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChunksAbortRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        's3Path': json['s3_path'],
        'uploadId': json['upload_id'],
    };
}

export function ChunksAbortRequestToJSON(value?: ChunksAbortRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        's3_path': value.s3Path,
        'upload_id': value.uploadId,
    };
}

